import type { DatadogRumAction } from 'src/utils/logging';
import { datadogRum } from '@datadog/browser-rum';
import InputField from '@savvy-kit/patterns/input-field';
import { debounce } from 'es-toolkit';
import { Search } from 'lucide-react';

type Props = {
  readonly datadogRumAction?: DatadogRumAction;
  readonly defaultValue?: string;
  readonly value?: string;
  readonly onChange: (event: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => void;
};

export function SearchField(props: Props) {
  const { datadogRumAction, defaultValue, value, onChange } = props;

  const debouncedDatadogLogInfo = debounce(datadogRum.addAction, 1000);

  const handleChange = (e: React.ChangeEvent<HTMLInputElement | HTMLTextAreaElement>) => {
    const value = e.target.value;

    // Trigger search for any non-empty query or empty (to clear results)
    if (value.length >= 1 || value.length === 0) {
      onChange(e);
      if (datadogRumAction !== undefined) {
        debouncedDatadogLogInfo(datadogRumAction);
      }
    }
  };

  return (
    <InputField
      id="clients-and-prospects-search"
      aria-label="Search by household, name, email, or phone"
      // Fixed 400px, matching the MUI original's minWidth/maxWidth — not full width:
      // the surrounding flex group is content-sized, so w-full would collapse it.
      // containerClassName sizes the field; className would only size the inner input.
      containerClassName="w-100"
      onChange={handleChange}
      placeholder="Search by household, name, email, or phone"
      prependInputAddon={<Search aria-hidden="true" />}
      value={value ?? defaultValue ?? ''}
    />
  );
}
